'use client';

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from './ui/shadcn/alert-dialog';

interface VersionUpdateDialogProps {
  open: boolean;
  serverVersion: string;
  onDismiss: () => void;
  onUpdate: () => void;
}

export const VersionUpdateDialog = ({ open, serverVersion, onDismiss, onUpdate }: VersionUpdateDialogProps) => {
  return (
    <AlertDialog open={open}>
      <AlertDialogContent data-testid="version-update-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>New Version Available</AlertDialogTitle>
          <AlertDialogDescription>
            A new version ({serverVersion}) of Clickster is available. Please update to get the latest features and
            improvements.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onDismiss} data-testid="version-remind-later">
            Remind me later
          </AlertDialogCancel>
          <AlertDialogAction onClick={onUpdate} data-testid="version-update-btn">
            Update
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
